import NewAppBar from "components/Navbars/AppBar";
import React, { useEffect, useState } from "react";

import { Box, Dialog } from "@mui/material";
import Footer from "views/Landing/Footer";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import SearchBar from "views/Offers/SearchBar";
import ListSpontaneous from "./ListSpontneous";
import useSpontaneousWithPagination from "hooks/usepontaneousWithPagination";

function SpontaneousPage() {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSpontaneous, setSelectedSpontaneous] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [location, setLocation] = useState("");
  const [mode, setMode] = useState("");
  const [type, setType] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const jobsLocation = useLocation();
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const { t } = useTranslation();

  const {
    handleSearch,
    spontaneousList,
    loading,
    error,
    pagination,
    goToNextPage,
    goToPreviousPage,
    goToPage,
    refreshSpontaneous,
  } = useSpontaneousWithPagination({
    searchTerm,
    location,
    showSnackbar,
    setSearchTerm,
    setLocation,
    t,
    type,
    mode,
  });

  useEffect(()=>{
    console.log('spontaneousList =>:', spontaneousList);
  },[spontaneousList])

  useEffect(()=>{
    console.log('spontaneousList data structure =>:', {
      length: spontaneousList?.length || 0,
      hasItems: spontaneousList?.length > 0,
      firstItem: spontaneousList?.length > 0 ? {...spontaneousList[0]} : null
    });
  },[spontaneousList]);

  // Extract search parameters from URL state
  useEffect(() => {
    // Only run this effect once when the component mounts or when location state changes
    if (jobsLocation && jobsLocation.state) {
      const {
        search: searchParam,
        location: locationParam,
        mode: modeParam,
        type: typeParam
      } = jobsLocation.state;

      console.log('Navigation params =>:', { searchParam, locationParam, modeParam, typeParam });

      // Set values only once when the component mounts with state
      setSearchTerm(searchParam || '');
      setLocation(locationParam || '');
      setMode(modeParam || '');
      setType(typeParam || '');
    }
  // Only depend on jobsLocation, not on searchTerm, location, or handleSearch
  }, []);
  
  // Separate effect to handle the search
  useEffect(() => {
    // Skip on initial render
    const shouldSearch = searchTerm || location || mode || type;
    if (shouldSearch) {
      // Use a ref to track if this is the first render
      const timer = setTimeout(() => {
        handleSearch({ preventDefault: () => {} });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleSpontaneousClick = (spontaneous) => {
    setSelectedSpontaneous(spontaneous);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedSpontaneous(null);
  };
  
  return (
    <Box>
      <NewAppBar />

      <Box
        sx={{
          marginLeft: { md: "60px", xs: "0" },
        }}
      >
        <SearchBar
          searchTerm={searchTerm}
          location={location}
          showSnackbar={showSnackbar}
          t={t}
          handleSearch={handleSearch}
          setLocation={setLocation}
          setSearchTerm={setSearchTerm}
          setType={setType}
          setMode={setMode}
          mode={mode}
          type={type}
        />
        <ListSpontaneous
          setSelectedSpontaneous={setSelectedSpontaneous}
          setOpenDialog={setOpenDialog}
          spontaneousList={spontaneousList}
          loading={loading}
          error={error}
          pagination={pagination}
          goToNextPage={goToNextPage}
          goToPreviousPage={goToPreviousPage}
          goToPage={goToPage}
          refreshSpontaneous={refreshSpontaneous}
        />
      </Box>
      <Footer />
    </Box>
  );
}

export default SpontaneousPage;